import { SharedState } from '@trello/shared-state';

export type SmartScheduleOnboardingAction = () => Promise<void> | void;

/**
 * The surface that launched onboarding. Used for analytics attribution so we can
 * tell which entry point drove a given onboarding session. These are a subset of
 * the analytics `SourceType` so they can be forwarded directly to events.
 */
export type SmartScheduleOnboardingEntryPoint =
  | 'bulkActionMenu'
  | 'memberAiSettingsScreen'
  | 'plannerSettingsPopover'
  | 'quickEditOverlay';

interface SmartScheduleOnboardingState {
  isVisible: boolean;
  pendingAction: SmartScheduleOnboardingAction | null;
  entryPoint: SmartScheduleOnboardingEntryPoint | null;
}

export const SMART_SCHEDULE_ONBOARDING_MESSAGE_ID = 'smart-schedule-onboarding';

export const smartScheduleOnboardingSharedState =
  new SharedState<SmartScheduleOnboardingState>({
    isVisible: false,
    pendingAction: null,
    entryPoint: null,
  });
